export enum DateError {
    InvalidFormat = 'InvalidFormat',
    InvalidDate = 'InvalidDate',
    MinDateError = 'MinDateError',
    MaxDateError = 'MaxDateError'
}
